// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-ads-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.ads-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

/* === ADS GRID === */
.ads-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 1.5rem;
}

.ad-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    transition: transform 0.2s, box-shadow 0.2s;
}

.ad-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
}

.active-ad-card {
    border: 2px solid #10b981;
    background: #f0fdf4;
}

.live-badge {
    position: absolute;
    top: -12px;
    right: 20px;
    background: #10b981;
    color: white;
    font-size: 0.75rem;
    font-weight: 800;
    padding: 0.3rem 0.8rem;
    border-radius: 99px;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);
    border: 2px solid white;
    letter-spacing: 0.5px;
}

.pulse-dot {
    height: 6px;
    width: 6px;
    background: white;
    border-radius: 50%;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
    }
}

.ad-card-content {
    display: flex;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.ad-icon-wrapper {
    height: 48px;
    width: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.bg-slate-light {
    background: #f1f5f9;
}

.text-slate {
    color: #64748b;
}

.text-green {
    color: #059669;
}

.ad-details {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.ad-text-preview {
    margin: 0;
    font-size: 1.15rem;
    color: #1e293b;
    font-weight: 700;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.ad-link-preview {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.9rem;
    color: #2563eb;
    text-decoration: none;
    word-break: break-all;
    font-weight: 500;
}

.ad-link-preview:hover {
    text-decoration: underline;
}

.ad-date {
    margin: 0.5rem 0 0 0;
    font-size: 0.8rem;
    color: #94a3b8;
}

/* === CARD ACTIONS === */
.ad-card-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    border-top: 1px solid rgba(226, 232, 240, 0.8);
    padding-top: 1rem;
}

.icon-action-btn {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    height: 40px;
    width: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    color: #64748b;
}

.icon-action-btn.edit:hover {
    background: #eff6ff;
    color: #2563eb;
    border-color: #bfdbfe;
}

.icon-action-btn.activate:hover {
    background: #f0fdf4;
    color: #10b981;
    border-color: #bbf7d0;
}

.icon-action-btn.deactivate:hover {
    background: #fffbeb;
    color: #d97706;
    border-color: #fde68a;
}

.icon-action-btn.delete:hover {
    background: #fef2f2;
    color: #ef4444;
    border-color: #fecaca;
}

/* === FORM MODAL === */
.form-modal {
    max-width: 500px;
    text-align: left;
    align-items: stretch;
}

.form-modal h3 {
    font-size: 1.5rem;
    margin: 0 0 0.5rem 0;
    text-align: left;
}

.admin-textarea {
    width: 100%;
    padding: 1rem;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    font-size: 1.05rem;
    font-family: inherit;
    outline: none;
    transition: border-color 0.2s;
    resize: vertical;
    box-sizing: border-box;
}

.admin-textarea:focus {
    border-color: #3b82f6;
}

/* Custom Checkbox */
.toggle-group {
    background: #f8fafc;
    padding: 1rem;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
}

.checkbox-container {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    height: 22px;
    width: 22px;
    background-color: white;
    border: 2px solid #cbd5e1;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.checkbox-container input:checked~.checkmark {
    background-color: #10b981;
    border-color: #10b981;
}

.checkmark:after {
    content: "";
    display: none;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    margin-bottom: 2px;
}

.checkbox-container input:checked~.checkmark:after {
    display: block;
}

.toggle-hint {
    margin: 0.5rem 0 0 2.1rem;
    font-size: 0.85rem;
    color: #64748b;
}

.elder-btn-warning-solid {
    background: #f59e0b;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s;
}

.elder-btn-warning-solid:hover {
    background: #d97706;
}

.bg-yellow-light {
    background: #fef3c7;
}

/* === RESPONSIVE === */
@media (max-width: 768px) {
    .ads-main-content {
        padding: 0 1rem 3rem 1rem;
    }

    .ads-grid {
        grid-template-columns: 1fr;
    }

    .form-modal {
        padding: 1.5rem;
    }

    .elder-modal-actions {
        flex-direction: column;
    }

    .elder-modal-actions button {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Advertisement.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,6CAA6C;IAC7C,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI;QACI,sBAAsB;QACtB,4CAA4C;IAChD;;IAEA;QACI,mBAAmB;QACnB,4CAA4C;IAChD;;IAEA;QACI,sBAAsB;QACtB,0CAA0C;IAC9C;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,8CAA8C;IAC9C,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".admin-ads-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.ads-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 1200px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* === ADS GRID === */\n.ads-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n    gap: 1.5rem;\n}\n\n.ad-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    position: relative;\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.ad-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n}\n\n.active-ad-card {\n    border: 2px solid #10b981;\n    background: #f0fdf4;\n}\n\n.live-badge {\n    position: absolute;\n    top: -12px;\n    right: 20px;\n    background: #10b981;\n    color: white;\n    font-size: 0.75rem;\n    font-weight: 800;\n    padding: 0.3rem 0.8rem;\n    border-radius: 99px;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);\n    border: 2px solid white;\n    letter-spacing: 0.5px;\n}\n\n.pulse-dot {\n    height: 6px;\n    width: 6px;\n    background: white;\n    border-radius: 50%;\n    animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n    0% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);\n    }\n\n    70% {\n        transform: scale(1);\n        box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);\n    }\n\n    100% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n    }\n}\n\n.ad-card-content {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.ad-icon-wrapper {\n    height: 48px;\n    width: 48px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.bg-slate-light {\n    background: #f1f5f9;\n}\n\n.text-slate {\n    color: #64748b;\n}\n\n.text-green {\n    color: #059669;\n}\n\n.ad-details {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.ad-text-preview {\n    margin: 0;\n    font-size: 1.15rem;\n    color: #1e293b;\n    font-weight: 700;\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.ad-link-preview {\n    display: flex;\n    align-items: center;\n    gap: 0.3rem;\n    font-size: 0.9rem;\n    color: #2563eb;\n    text-decoration: none;\n    word-break: break-all;\n    font-weight: 500;\n}\n\n.ad-link-preview:hover {\n    text-decoration: underline;\n}\n\n.ad-date {\n    margin: 0.5rem 0 0 0;\n    font-size: 0.8rem;\n    color: #94a3b8;\n}\n\n/* === CARD ACTIONS === */\n.ad-card-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    border-top: 1px solid rgba(226, 232, 240, 0.8);\n    padding-top: 1rem;\n}\n\n.icon-action-btn {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    height: 40px;\n    width: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n    color: #64748b;\n}\n\n.icon-action-btn.edit:hover {\n    background: #eff6ff;\n    color: #2563eb;\n    border-color: #bfdbfe;\n}\n\n.icon-action-btn.activate:hover {\n    background: #f0fdf4;\n    color: #10b981;\n    border-color: #bbf7d0;\n}\n\n.icon-action-btn.deactivate:hover {\n    background: #fffbeb;\n    color: #d97706;\n    border-color: #fde68a;\n}\n\n.icon-action-btn.delete:hover {\n    background: #fef2f2;\n    color: #ef4444;\n    border-color: #fecaca;\n}\n\n/* === FORM MODAL === */\n.form-modal {\n    max-width: 500px;\n    text-align: left;\n    align-items: stretch;\n}\n\n.form-modal h3 {\n    font-size: 1.5rem;\n    margin: 0 0 0.5rem 0;\n    text-align: left;\n}\n\n.admin-textarea {\n    width: 100%;\n    padding: 1rem;\n    border: 2px solid #e2e8f0;\n    border-radius: 10px;\n    font-size: 1.05rem;\n    font-family: inherit;\n    outline: none;\n    transition: border-color 0.2s;\n    resize: vertical;\n    box-sizing: border-box;\n}\n\n.admin-textarea:focus {\n    border-color: #3b82f6;\n}\n\n/* Custom Checkbox */\n.toggle-group {\n    background: #f8fafc;\n    padding: 1rem;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n}\n\n.checkbox-container {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    cursor: pointer;\n    user-select: none;\n}\n\n.checkbox-container input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n\n.checkmark {\n    height: 22px;\n    width: 22px;\n    background-color: white;\n    border: 2px solid #cbd5e1;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.checkbox-container input:checked~.checkmark {\n    background-color: #10b981;\n    border-color: #10b981;\n}\n\n.checkmark:after {\n    content: \"\";\n    display: none;\n    width: 6px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    margin-bottom: 2px;\n}\n\n.checkbox-container input:checked~.checkmark:after {\n    display: block;\n}\n\n.toggle-hint {\n    margin: 0.5rem 0 0 2.1rem;\n    font-size: 0.85rem;\n    color: #64748b;\n}\n\n.elder-btn-warning-solid {\n    background: #f59e0b;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.elder-btn-warning-solid:hover {\n    background: #d97706;\n}\n\n.bg-yellow-light {\n    background: #fef3c7;\n}\n\n/* === RESPONSIVE === */\n@media (max-width: 768px) {\n    .ads-main-content {\n        padding: 0 1rem 3rem 1rem;\n    }\n\n    .ads-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .form-modal {\n        padding: 1.5rem;\n    }\n\n    .elder-modal-actions {\n        flex-direction: column;\n    }\n\n    .elder-modal-actions button {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
